import { Box } from "@mui/material";

import { MessageSenderInfo } from "../../../../../../Chat/types/message";
import { useScrollToBottom } from "../../../../../../Chat/hooks/useScrollToBottom";
import { useServiceChatThread } from "../../../../../../Chat/hooks/useServiceChatThread";

import ChatInput from "./ChatInput";
import MessagesList from "./MessagesList";

const ChatContainer = ({
  threadId,
  currentUser,
  otherUser,
  requestId,
}: {
  threadId: string;
  currentUser: MessageSenderInfo;
  otherUser: MessageSenderInfo;
  requestId?: string;
}) => {
  const { messages, handleSendTextMessage, handleOnKeyDownWithinChatInput, chatInputRef } = useServiceChatThread({
    threadId,
    requestId,
  });
  const { elementRef, scrollToBottom } = useScrollToBottom(messages);

  return (
    <Box sx={styles.container}>
      <MessagesList messages={messages} currentUser={currentUser} otherUser={otherUser} ref={elementRef} />
      <ChatInput
        chatInputRef={chatInputRef}
        onSendMessage={handleSendTextMessage}
        onKeyDown={handleOnKeyDownWithinChatInput}
        scrollToBottomOfChatContainer={scrollToBottom}
      />
    </Box>
  );
};

export default ChatContainer;

const styles = {
  container: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
